module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-08directivos-y-consejeros.4362ca25.jpg";